import { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import { useForm } from 'react-hook-form';
import { Box, Button, FormControl, Grid, Stack, TextField } from '@mui/material';
import { ForwardToInbox, HighlightOff } from '@mui/icons-material';
import LoadingButton from '../../@iosper/components/LoadingButton';
import { enviarAutorizacion } from '../../services/Afiliado/Autorizaciones';
import ModalBase from '../Controls/ModalBase';

const EnviarAutorizacionPopUp = ({ title, subtitle, ...props }) => {
  const [datos, setDatos] = useState({
    idAutorizacion: props.autorizacion?.id,
    correo: props.autorizacion?.correo,
  });

  const [loadingEnviar, setLoadingEnviar] = useState(false);

  useEffect(() => {}, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({ mode: 'onBlur' });

  const onEnviarAutorizacion = async (data, event) => {
    event.preventDefault();
    setLoadingEnviar(true);
    try {
      setLoadingEnviar(true);
      const res = await enviarAutorizacion(datos);
      if (res) {
        setLoadingEnviar(false);
        props.setAutorizacion(true);
      }
    } catch (e) {
      setLoadingEnviar(false);
    }
  };

  const handleClose = () => {
    props.onCancelar();
  };

  const DrawerForm = (
    <form onSubmit={handleSubmit(onEnviarAutorizacion)}>
      <FormControl fullWidth={true} variant='outlined' margin='normal'>
        <TextField
          multiline
          maxRows={4}
          {...register('correo', {
            required: {
              value: true,
              message: 'El campo es requerido',
            },
            pattern: {
              value:
                '^(([^<>()\\[]\\.,;:s@"]+(.[^<>()\\[]\\.,;:s@"]+)*)|(".+"))@(([[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}.[0-9]{1,3}])|(([a-zA-Z-0-9]+.)+[a-zA-Z]{2,}))$/',
              message: 'El formato no es correcto (nombre@dominio.com)',
            },
          })}
          variant='standard'
          fullWidth
          name='correo'
          label='Correo electrónico'
          id='Correo'
          value={datos.correo}
          onChange={(newValue) => {
            setDatos({ ...datos, correo: newValue.target.value });
          }}
        />
        {errors.correo && <p style={{ color: 'red' }}>{errors.correo.message}</p>}
      </FormControl>

      <Box sx={{ width: '100%', padding: '10px' }}>
        <Stack
          direction={{ xs: 'column', sm: 'row' }}
          spacing={{ xs: 1, sm: 2 }}
          justifyContent={{ xs: 'center', sm: 'flex-end' }}
        >
          <Button
            variant='contained'
            startIcon={<HighlightOff />}
            color='neutral'
            onClick={handleClose}
          >
            Cancelar
          </Button>
          <LoadingButton
            fullWidth={true}
            variant='contained'
            size='medium'
            color='primary'
            startIcon={<ForwardToInbox />}
            type='submit'
            loading={loadingEnviar ? 'show' : 'hide'}
            content={'Enviar'}
          />
        </Stack>
      </Box>
    </form>
  );

  const popUpEnviar = (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography gutterBottom>
          {subtitle || `Correo electrónico del destinatario de la solicitud`}
        </Typography>
        {DrawerForm}
      </Grid>
    </Grid>
  );

  return (
    <Box sx={{ width: '100%' }}>
      <ModalBase
        fullWidth={false}
        open={true}
        content={popUpEnviar}
        title={title || 'Enviar Solicitud de Autorización'}
        setAutorizacion={props.setAutorizacion}
      />
    </Box>
  );
};

export default EnviarAutorizacionPopUp;
